export function announceStatus(message) {
  window.dispatchEvent(new CustomEvent("app-status", { detail: message }));
}
